import { MutationTree } from 'vuex';
import {
  ISettingsBillingState,
  IUpdateDetails,
  EnumChargeBeeState,
} from '../stores/settings-billing.store';
import { ICurrency } from '@/types/Currency';
import { IPlan } from '@/types/Plans';
import { EnumPlans } from '@/enums/Plans';

export const mutationError = 'error';
export const mutationLoading = 'loading';
export const mutationSaving = 'saving';
export const mutationSetBillingDetails = 'setBillingDetails';
export const mutationSetBillingCurrency = 'setBillingCurrency';
export const mutationSetPlanType = 'setPlanType';
export const mutationSetPlan = 'setPlan';
export const mutationSetShowContactSalesModal = 'setShowContactSalesModal';
export const mutationSetShowUpdatePlanModal = 'setShowUpdatePlanModal';
export const mutationSetShowConfirmStarterModal = 'setShowConfirmStarterModal';
export const mutationSetUserCount = 'setUserCount';
export const mutationSetUpdateDetails = 'setUpdateDetails';
export const mutationSetChargebeeState = 'setChargebeeState';

export const mutations: MutationTree<ISettingsBillingState> = {
  [mutationError](state: ISettingsBillingState, error: string) {
    state.error = error;
  },
  [mutationLoading](state: ISettingsBillingState, payload: boolean) {
    state.isLoading = payload;
  },
  [mutationSetBillingDetails](state: ISettingsBillingState, payload: ISettingsBillingState) {
    Object.assign(state, {
      ...state,
      ...payload,
    });
  },
  [mutationSetBillingCurrency](state: ISettingsBillingState, payload: ICurrency) {
    state.billingCurrency = payload;
  },
  [mutationSetPlan](state: ISettingsBillingState, payload: IPlan) {
    state.plan = payload;
  },
  [mutationSetPlanType](state: ISettingsBillingState, payload: EnumPlans) {
    state.planType = payload;
  },
  [mutationSetShowContactSalesModal](state: ISettingsBillingState, payload: boolean) {
    state.showContactSalesModal = payload;
  },
  [mutationSetShowConfirmStarterModal](state: ISettingsBillingState, payload: boolean) {
    state.showConfirmStarterModal = payload;
  },
  [mutationSetShowUpdatePlanModal](state: ISettingsBillingState, payload: boolean) {
    state.showUpdatePlanModal = payload;
  },
  [mutationSetUserCount](state: ISettingsBillingState, payload: number) {
    state.userCount = payload;
  },
  [mutationSaving](state: ISettingsBillingState, payload: boolean) {
    state.isSaving = payload;
  },
  [mutationSetUpdateDetails](state: ISettingsBillingState, payload: IUpdateDetails) {
    state.updateDetails = payload;
  },
  [mutationSetChargebeeState](state: ISettingsBillingState, payload: EnumChargeBeeState) {
    state.chargeBeeState = payload;
  },
};
